import { Component, OnInit } from '@angular/core';
import { AuthGuard } from 'src/app/authGuardClass';
import { ComponentsService } from 'src/app/components.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
    clients: [];
    loadedPerms: boolean = false;
    username: string;
    perms;
    activeClient;
    env;
    opened = true;

    constructor(
        private service: ComponentsService,
        private authGuard: AuthGuard
    ) {}

    ngOnInit(): void {
        this.perms = this.service.getUsersPerm();
        console.log(`perms: ${JSON.stringify(this.perms)}`);

        // Get the proper client name from the API for all users
        this.service.setClientUuid(this.perms.clientUuid);
        this.service.setSelectedClientUuid(this.perms.clientUuid);
        this.service
            .clientName(this.service.getClientUuid())
            .subscribe((data) => {
                this.activeClient = data.clientName;
            });

        // Only get client names list if the user is a superadmin
        if (this.perms && this.perms.superAdmin == 1) {
            this.service.getClientNames().subscribe((clients) => {
                this.clients = clients.data;
            });
        }

        this.loadedPerms = true;
        this.service.setClientUuid(this.perms.clientUuid);
        this.service.setSelectedClientUuid(this.perms.clientUuid);

        this.env = environment.path;
    }

    logOut() {
        this.authGuard.logOut();
    }
    //KADA SE MENJA KLIJENT (  SUPER ADMIN );

    clientChange(client) {
        console.log(
            `[HeaderComponent] Before changeClient: selectedClientUuid=${this.service.getSelectedClientUuid()}`
        );
        this.service.changeClient(client.clientUuid);
        console.log(
            `[HeaderComponent] After changeClient: selectedClientUuid=${this.service.getSelectedClientUuid()}`
        );
        this.service.clientChanged.emit(client);

        // Update the activeClient with the proper client name
        this.service
            .clientName(this.service.getClientUuid())
            .subscribe((data) => {
                this.activeClient = data.clientName;
            });
    }
    //KADA SE MENJA KLIJENT (  SUPER ADMIN );
}
